import React, { useEffect, useState } from "react";
import { getUserData } from "../../api/users";
import Logout from "./Logout";
import StatementRenderer, { UserData } from "../../utilities/StatementRenderer";
import d from '../../schema/response.json'

interface HomeProps {
  onLogout: () => void;
}

const Home: React.FC<HomeProps> = ({ onLogout }) => {
  const [rawData, setRawData] = useState<any>();

  const fetchData = async () => {
  try {
    const userId: number = Number(sessionStorage.getItem('userId'));
    if (!userId) {
      throw new Error('Email not found in session storage');
    }
    const result = await getUserData(userId);
    if (result) {
      sessionStorage.setItem('name', String(result.name));
      setRawData(result);
    } else {
      setRawData(null); // or handle "no user" state as you wish
    }
  } catch (error) {
    console.error('Error fetching data:', error);
    setRawData(null);
  }
};

  useEffect(() => {
    fetchData();
  }, [])

  return (
    <div>
    { rawData ? (
      <StatementRenderer rawData={rawData} />
    ) : (
      <p>No data found</p>
    )}
  </div>
  );
};
export default Home;
